import { render } from "./BenchmarkParameters.vue?vue&type=template&id=f05a0886&scoped=true"
import script from "./BenchmarkParameters.vue?vue&type=script&lang=js"
export * from "./BenchmarkParameters.vue?vue&type=script&lang=js"

import "./BenchmarkParameters.vue?vue&type=style&index=0&id=f05a0886&scoped=true&lang=css"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f05a0886"]])

export default __exports__